import React from "react";
import { Text, Flex, Link as ChakraLink } from "@chakra-ui/react";
import { IoLogoGithub } from "react-icons/io";
import { FiUpload } from "react-icons/fi";
import { GoLinkExternal } from "react-icons/go";
import { FaCodeBranch } from "react-icons/fa";
import { FaCodeCommit } from "react-icons/fa6";

interface ProjectInfoDisplayProps {
  projectInfo: ProjectInfoUrl | ProjectInfoGithub | ProjectInfoManual;
  projectType: string;
  fontSize?: string;
  color?: string;
  justifyContent?: "left" | "center";
}

const ProjectInfoDisplay: React.FC<ProjectInfoDisplayProps> = ({
  projectInfo: projectInfoProp,
  projectType,
  fontSize = "sm",
  color = "gray.700",
  justifyContent = "left",
}) => {
  if (projectType === "github") {
    const projectInfo = projectInfoProp as ProjectInfoGithub;
    return (
      <ChakraLink
        href={`https://github.com/${projectInfo?.repositoryFullName}`}
        fontSize={fontSize}
        display="inline-block"
        target="_blank"
        width="100%"
      >
        <Flex
          alignItems="center"
          gap={1}
          justifyContent={justifyContent}
          flexWrap={{ base: "wrap", md: "nowrap" }}
          fontSize={{ base: "xs", sm: fontSize }}
        >
          <IoLogoGithub />
          <Text isTruncated maxW={{ base: "200px", sm: "300px", md: "full" }}>
            {projectInfo?.repositoryFullName}
          </Text>
        </Flex>
        <Flex
          alignItems="center"
          gap={1}
          justifyContent={justifyContent}
          flexWrap={{ base: "wrap", md: "nowrap" }}
          fontSize={{ base: "xs", sm: fontSize }}
        >
          <FaCodeBranch />
          <Text>{projectInfo?.branchName || "main"}</Text>
          {!!projectInfo?.lastCommitMessage && (
            <>
              <Text> / </Text>
              <FaCodeCommit />
              <Text
                isTruncated
                maxW={{ base: "150px", sm: "250px", md: "full" }}
              >
                {projectInfo?.lastCommitMessage}
              </Text>
            </>
          )}
        </Flex>
      </ChakraLink>
    );
  } else if (projectType === "url") {
    const projectInfo = projectInfoProp as ProjectInfoUrl;
    return (
      <ChakraLink
        href={projectInfo?.url}
        display="inline-block"
        fontSize={fontSize}
        color={color}
        target="_blank"
        width="100%"
      >
        <Flex
          alignItems="center"
          gap={1}
          justifyContent={justifyContent}
          flexWrap={{ base: "wrap", md: "nowrap" }}
          fontSize={{ base: "xs", sm: fontSize }}
        >
          <GoLinkExternal />
          <Text isTruncated maxW={{ base: "240px", sm: "350px", lg: "450px" }}>
            {projectInfo?.url}
          </Text>
        </Flex>
        <Flex
          alignItems="center"
          gap={1}
          justifyContent={justifyContent}
          flexWrap={{ base: "wrap", md: "nowrap" }}
          fontSize={{ base: "xs", sm: fontSize }}
        >
          <FaCodeBranch />
          <Text>{projectInfo?.branchName || "main"}</Text>
          {!!projectInfo?.lastCommitMessage && (
            <>
              <Text> / </Text>
              <FaCodeCommit />
              <Text
                isTruncated
                maxW={{ base: "240px", md: "300px", lg: "450px" }}
              >
                {projectInfo?.lastCommitMessage}
              </Text>
            </>
          )}
        </Flex>
      </ChakraLink>
    );
  } else if (projectType === "upload") {
    return (
      <Flex align="center" gap={1} justifyContent={justifyContent} width="100%">
        <FiUpload />
        <Text>Manual Upload</Text>
      </Flex>
    );
  }

  return null;
};

export default ProjectInfoDisplay;
